import { Capacitor } from "@capacitor/core";
import {
    BarcodeScanner,
    BarcodeFormat,
    LensFacing,
} from "@capacitor-mlkit/barcode-scanning";

export function isNativeScannerAvailable() {
    return Capacitor.isNativePlatform();
}

export async function scanPassQrNative() {
    if (!Capacitor.isNativePlatform()) return "";

    const { supported } = await BarcodeScanner.isSupported();
    if (!supported) {
        throw new Error("Barcode scanning is not supported on this device.");
    }

    // Android ready-made scanner depends on Google Barcode Scanner module.
    const moduleStatus =
        typeof BarcodeScanner.isGoogleBarcodeScannerModuleAvailable === "function"
            ? await BarcodeScanner.isGoogleBarcodeScannerModuleAvailable()
            : { available: true };

    if (!moduleStatus.available) {
        if (typeof BarcodeScanner.installGoogleBarcodeScannerModule === "function") {
            await BarcodeScanner.installGoogleBarcodeScannerModule();
        }
        throw new Error(
            "Preparing scanner. Please tap Open Camera Scanner again in a moment."
        );
    }

    const result = await BarcodeScanner.scan({
        formats: [BarcodeFormat.QrCode],
        lensFacing: LensFacing.Back,
        autoZoom: true,
    });

    const first = result?.barcodes?.[0];
    const rawValue =
        first?.rawValue ||
        first?.displayValue ||
        "";

    return String(rawValue).trim();
}

export function describeNativeScannerError(error) {
    const raw = String(error?.message || error || "");
    const msg = raw.toLowerCase();

    if (!raw) return "Could not open the scanner.";
    if (msg.includes("cancel")) return "Scan canceled.";
    if (msg.includes("preparing scanner")) return raw;
    if (msg.includes("not supported")) return raw;
    if (msg.includes("permission")) {
        return "Camera permission is blocked. Open app settings and allow camera access.";
    }
    return raw;
}